import {
	ESignProvider,
	InvestmentProgrammeDocumentDetailsSignerRes,
	SignatureType,
} from '@dealstack/shared/lib/generated';
import { isConcludedStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/Documents.utils';

/**
 * Mirrors the backend `isClaimableSigningConfig`: claim & sign on behalf is only
 * supported for electronic documents signed via eID Easy. Everything else is out
 * of scope — wet-ink documents go through the investor uploading a signed copy — so
 * the claim controls must not appear for them, otherwise the action fails at the
 * backend with "This signing configuration cannot be claimed".
 */
export const isClaimableDocumentConfig = (
	signatureType: SignatureType | undefined,
	eSignProvider: ESignProvider | null | undefined
): boolean =>
	signatureType === SignatureType.ELECTRONIC && eSignProvider === ESignProvider.EID_EASY;

/**
 * Returns true when the admin can claim & sign on behalf of this panel signer.
 * Uses the signer shape from InvestmentProgrammeDocumentDetailsSignerRes:
 * - `id`            — the signer id (must be present to call the claim endpoint)
 * - `claimedByName` — if set, the signer is already claimed
 * - `status`        — any concluded status (the "signed" ones, plus CLOSED_WITHOUT_SIGNATURE
 *                     once an admin has closed the document) → cannot be claimed
 */
export const canClaimSigner = (
	signer: Pick<InvestmentProgrammeDocumentDetailsSignerRes, 'id' | 'status' | 'claimedByName'>
): boolean => !signer.claimedByName && !!signer.id && !isConcludedStatus(signer.status);
